import { createLayout, type Layout } from '@atlassian/jira-route-layout/src/GlobalComponent.tsx';

export const userBoardLayout: Layout = createLayout();
